import { gate } from 'hub-http/gates';
export const REPORTING_AI_INSIGHTS_SLIDER_GATE = 'reportingAI:insightSlider';
export const ENABLE_DATE_PROPERTY_FOR_ALL_CONFIG_REPORTS = gate('ReportingEnablement:EnableDatePropertyForAllConfigReports');
export const STATIC_GOAL_EDITOR = gate('RE:StaticGoalEditor');
export const ADDITIONAL_OBJECT_TYPES_IN_SRV = gate('Goals:SRV:AdditionalObjectTypes');
export const TABLE_REPORT_INSIGHTS_GATE = gate('ReportingInsightsCopilot:TableReportInsightsGate');
export const REPORTING_INSIGHTS_COPILOT_TOOL_GATE = gate('ReportingPlatform:ReportingInsightsCopilotTool');
export const ADDITIONAL_OBJECT_TYPES_IN_SRV_GATE = gate('Goals:SRV:AdditionalObjectTypes');
export const REPORTING_ENABLEMENT_SRV_REPORT_PRESETS_GATE = gate('ReportingEnablement:srvReportPresets');
export const AI_INSIGHTS_UPDATE_GATE = gate('ReportingEnablement:AIInsightUpdate');
export const AI_INSIGHTS_SETTINGS_GATE = gate('ReportingEnablement:AIInsightsSettings');
export const JOURNEY_AI_INSIGHTS_GATE = gate('MR:JourneyAIInsights');
export const REPORT_REFRESH_GATE = gate('ReportingEnablement:RefreshReportUpdates');
export const SRV_REPORT_CARD_V2_MIGRATION_GATE = gate('RE:SRVReportCardV2Migration');
export const SRV_REDESIGN_2025_Q2_GATE = gate('RE:SRV:Redesign2025Q2');
export const GENERATE_AI_INSIGHTS_ENDPOINT_V2_GATE = gate('ReportingEnablement:GenerateAIInsightsEndpointV2');
export const SRV_VIEW_MODE_REMIXES_GATE = gate('RE:SRVViewMode:Remixes');
export const SRV_VIEW_MODE_NAVIGATION_GATE = gate('RE:SRVViewMode:Navigation');
export const UEQL_FILTERS_V2_GATE = gate('ReportCreation:UEQLFiltersV2');
export const SRV_REPORT_COMPARISON_DROPDOWN_GATE = gate('ReportingEnablement:replaceCompareEditor');
export const SRV_REPORT_FREQUENCY_DROPDOWN_GATE = gate('ReportingEnablement:replaceFrequencyEditor');
export const ENHANCED_CRM_METRIC_BUTTONS_GATE_V1 = gate('ReportingEnablement:EnhancedMetricsV1MetricButtons');
export const SRV_LITE_EDITING_SNOWFLAKE_GATE = gate('ReportCreation:ReportOptionsCRBBased');
export const getIsUngatedToSRVLiteEditingSnowflake = gates => gates.includes(SRV_LITE_EDITING_SNOWFLAKE_GATE);
export const getIsUngatedForUESearchReportEditing = (gates = []) => {
  return gates.includes(gate('ReportCreation:UESearchReportOptions'));
};
export const getIsUngatedForUESearchAIEditing = (gates = []) => {
  return gates.includes(gate('ReportCreation:UESearchAIEditing'));
};
export const getIsUngatedNLPPropertySearch = (gates = []) => {
  return gates.includes(gate('ReportingEnablement:EnableNLPPropertySearch'));
};
export const getIsUngatedForUEQLORFilters = (gates = []) => gates.includes(gate('ReportingEnablement:FiltersV2:UEQLORFilters'));
export const getIsUngatedForUEQLFiltersV2 = (gates = []) => gates.includes(UEQL_FILTERS_V2_GATE);